import { render, staticRenderFns } from "./tradedetail.vue?vue&type=template&id=4404b424&scoped=true"
import script from "./tradedetail.vue?vue&type=script&lang=js"
export * from "./tradedetail.vue?vue&type=script&lang=js"
import style0 from "./tradedetail.vue?vue&type=style&index=0&id=4404b424&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404b424",
  null
  
)

export default component.exports